import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InfoContent from '../../../components/common/InfoContent';
import { useGlobalContext } from '../../../context/GlobalContext';

const ClientId = ({ userData, setUserData, formErrors, setFormErrors }) => {
  const { t } = useTranslation();
  const {
    store,
    validateClientId
  } = useGlobalContext();
  
  const [localClientId, setLocalClientId] = useState('');
  const [infoField, setInfoField] = useState('');
  const [touched, setTouched] = useState(false);
  
  useEffect(() => {
    if (userData?.clientId) {
      setLocalClientId(userData.clientId);
    }
  }, [userData?.clientId]);
  
  if (!store?.clientIdType) return null;
  
  const clientIdType = store.clientIdType.toUpperCase();
  const placeholderKey = `clientId.placeholder.${clientIdType}`;
  const tooltipKey = `clientId.tooltip.${clientIdType}`;
  const isOptional = store.isClientIdOptional;
  
  const handleChange = (e) => {
    const value = e.target.value;
    setLocalClientId(value);
    setUserData(prev => ({ ...prev, clientId: value }));
    if (formErrors?.clientIdError) {
      setFormErrors(prev => ({ ...prev, clientIdError: '' }));
    }
  };
  
  const handleBlur = () => {
    setTouched(true);
  };
  
  const getFormatExample = () => {
    switch (clientIdType) {
      case 'IKEA_FAMILY':
        return '6275980XXXXXXXXXXXX';
      case 'IKEA_BUSINESS':
        return '6275986XXXXXXXXXXXX';
      default:
        return '627598XXXXXXXXXXXXX';
    }
  };
  
  const handleShowInfo = (field) => {
    setInfoField(field);
  };
  
  const handleHideInfo = () => {
    setInfoField('');
  };
  
  const isValid = localClientId ? validateClientId(localClientId) : isOptional;
  const showError = (touched && localClientId && !isValid) || formErrors?.clientIdError;
  const errorMessage = formErrors?.clientIdError || t('Numéro de carte IKEA invalide');
  
  return (
    <div className="formField">
      <div className="formControl hasInfo">
        <input
          type="text"
          name="clientId"
          id="clientId"
          value={localClientId}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={`${t(placeholderKey) || 'N° carte IKEA FAMILY/BUSINESS'}${isOptional ? '' : '*'}`}
          className={showError ? 'error' : ''}
          required={!isOptional}
          aria-label={t("N° carte IKEA FAMILY/BUSINESS")}
          aria-invalid={showError ? "true" : "false"}
          aria-describedby={showError ? "error-clientId" : undefined}
        />
        <InfoContent
          id="forClientId"
          context="ikeaFamily"
          infoField={infoField}
          showInfo={() => handleShowInfo('forClientId')}
          hideInfo={handleHideInfo}
          infoText={t(tooltipKey) || `Format attendu: ${getFormatExample()}`}
          ariaLabelShow={t("Informations sur le numéro de carte IKEA")}
          ariaLabelHide={t("Fermer les informations")}
        />
        {showError && (
          <div className="error-message" id="error-clientId" role="alert">
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientId;